module.exports = __webpack_public_path__ + "static/EPD-logo_eng-ce78c18fa6095a47e21258140b6b3332.jpg";